import { laneOccupationForm, ROAD_ORGAN } from "modules/ebiForms/definitions/sharedRoads";
import { EEbiFormOffice } from "modules/ebiForms/typings";

/**
 * E8. Wniosek o wydanie zezwolenia na zajęcie pasa drogowego drogi powiatowej — art. 40 ust. 1–5, 8 i 11 ustawy o drogach
 * publicznych, § 1 ust. 2–6 rozporządzenia RM z 1.06.2004 r. (t.j. Dz.U. 2016 poz. 1264). Brak wzoru ogólnopolskiego;
 * układ jak wzór Powiatu Siedleckiego (https://samorzad.gov.pl/attachment/499715b8-a01c-4f7f-bf3a-7a0338371d73 — pobrany
 * 2026-10-22: tak): droga, miejscowość i gmina, infrastruktura telekomunikacyjna tak/nie, decyzja lokalizacyjna z art. 39
 * ust. 3, powierzchnia wg elementów pasa, okres od–do albo harmonogram, wykonawca i kierownik robót, oświadczenie z § 1
 * ust. 5 pkt 2. Wspólny builder z B5 i D1 (definitions/sharedRoads.ts); stawki — uchwała rady powiatu.
 */
const E8 = laneOccupationForm({
  code: "E8",
  title: "Wniosek o wydanie zezwolenia na zajęcie pasa drogowego drogi powiatowej",
  description: "Zezwolenie zarządcy drogi powiatowej na zajęcie pasa drogowego: roboty, urządzenia obce, reklamy, zajęcie na prawach wyłączności.",
  organ: ROAD_ORGAN.countyUnit,
  office: EEbiFormOffice.CountyUnit,
  road: "powiatowa",
});

export default E8;
